/**
 * ConfigAPIService is a service class that manages configuration settings and listeners.
 * It integrates with AngularJS services to fetch and update configuration data.
 */
class ConfigAPIService {
    /**
     * Constructs a new ConfigAPIService instance.
     * @param {Object} $config - The configuration service.
     * @param {Object} IAAPreferencesService - The preferences service.
     * @param {Object} $rootScope - The root scope service.
     */
    constructor($config, IAAPreferencesService, $rootScope) {
        this.$config = $config;
        this.IAAPreferencesService = IAAPreferencesService;
        this.$rootScope = $rootScope;
        this.task_info = undefined;
        this.listener = [];
    }

    /**
     * Initializes the service with task information and sets up a watcher for configuration changes.
     * @param {Object} task_info - The task information object.
     */
    init(task_info) {
        this.task_info = task_info;

        // Watch for changes in the configuration and notify listeners
        this.$rootScope.$watch(angular.bind(this, function () {
            return this.get_config();
        }), angular.bind(this, function (newVal, oldVal) {
            if (newVal === oldVal) return;

            // Notify each listener about the configuration change
            angular.forEach(this.listener, function(listener) {
                listener.source.postMessage([newVal, listener['data'][3]], listener.origin);
            });

        }), true);
    }

    /**
     * Retrieves the current configuration settings.
     * @returns {Object} The configuration object.
     */
    get_config() {
        return {
            'system_language': this.task_info.getISOLanguageCode(),
            'input_language': this.task_info.getISOInputLanguageCode(),
            'dyslexia_font_active': !!this.IAAPreferencesService.getPreference('dyslexicFont'),
            // 'colour_theme_active': '123',
            // 'colour_theme': '123',
            'zoom_level': this.IAAPreferencesService.getPreference('zoomLevel') || 100,
            'pdf_mode': this.$config.isPDFMode()
        };
    }

    /**
     * Registers a new listener for configuration changes.
     * @param {Object} messageEvent - The message event object containing listener details.
     * @returns {Object} The current configuration.
     */
    register_listener(messageEvent) {
        this.listener.push(messageEvent);
        return this.get_config();
    }
}

// Dependency injection annotations
ConfigAPIService.$inject = ['$config', 'IAAPreferencesService', '$rootScope'];

export default ConfigAPIService;